import axios from 'axios'

const BASE_URL = import.meta.env.VITE_API_BASE_URL

export const postEventMap = async (body) => {
  const rawToken = window.localStorage.getItem('token')

  if (!rawToken) {
    return {
      responseStatus: 401,
      data: { message: 'User is not authenticated.' },
    }
  }

  const STORAGE_TOKEN = JSON.parse(rawToken)

  let config = {
    headers: {
      Authorization: 'Bearer ' + STORAGE_TOKEN,
    },
    withCredentials: true,
  }
  return await axios
    .post(`${BASE_URL}event-maps`, body, config)
    .then((response) => {
      return {
        data: response.data,
        responseStatus: response.status,
      }
    })
    .catch(function (error) {
      if (error.response?.status === 401) {
        window.localStorage.clear()
        window.location.reload()
      }
      console.log('error postEventMap', error.response?.data)
      return {
        responseStatus: error.response?.status ?? 500,
        data: error.response?.data,
      }
    })
}
export const getCampaignDownloadPurchased = async (campaignId) => {
  const rawToken = window.localStorage.getItem('token')

  if (!rawToken) {
    return {
      responseStatus: 401,
      data: { purchased: false },
    }
  }

  const STORAGE_TOKEN = JSON.parse(rawToken)

  const config = {
    headers: {
      Authorization: 'Bearer ' + STORAGE_TOKEN,
    },
    withCredentials: true,
  }

  return await axios
    .get(
      `${BASE_URL}event-maps/campaign-download-purchased?campaignId=${encodeURIComponent(campaignId)}`,
      config,
    )
    .then((response) => ({
      data: response.data,
      responseStatus: response.status,
    }))
    .catch(function (error) {
      if (error.response?.status === 401) {
        window.localStorage.clear()
        window.location.reload()
      }
      console.log('error getCampaignDownloadPurchased', error.response?.data)
      return {
        responseStatus: error.response?.status ?? 500,
        data: { purchased: false },
      }
    })
}

export const getEventByName = async (eventName) => {
  const STORAGE_TOKEN = JSON.parse(window.localStorage.getItem('token'))

  let config = {
    headers: {
      Authorization: 'Bearer ' + STORAGE_TOKEN,
    },
    withCredentials: true,
  }
  return await axios
    .get(`${BASE_URL}event-maps/event?eventName=${eventName}`, config)
    .then((response) => {
      return {
        data: response.data,
        responseStatus: response.status,
      }
    })
    .catch(function (error) {
      if (error.response.status === 401) {
        window.localStorage.clear()
        window.location.reload()
      }
      console.log('error postEventMap', error.response.data)
      return error
    })
}

